import { useToast } from "@chakra-ui/react"
import { useState } from "react"
import { Button } from "src/components/ui/button"
import { Input } from "src/components/ui/input"
import { Label } from "src/components/ui/label"
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "src/components/ui/popover"

const SuggestionPill = ({ 
  data, 
  handleAcceptSuggestion, 
  disabled, 
  isLoading,
  isOpen,
  onOpenChange
}: { 
  data: {
    shortDescription: string;
    longDescription: string;
    value: string;
  }, 
  handleAcceptSuggestion: (data: any) => void, 
  disabled: boolean, 
  isLoading: boolean,
  isOpen: boolean,
  onOpenChange: (open: boolean) => void
}) => {
    const [name, setName] = useState(data?.shortDescription);
    const [value, setValue] = useState(data?.value);

    const toast = useToast();

    return (
        <Popover open={isOpen} onOpenChange={onOpenChange}>
            <PopoverTrigger asChild>
                <Button className={`rounded-full ${disabled ? 'bg-blue-700 text-white hover:bg-blue-800' : ''}`} >{name}</Button>
            </PopoverTrigger>
            <PopoverContent className="w-80">
                <div className="grid gap-4">
                    <div className="space-y-2">
                        <h4 className="font-medium leading-none">Ai Suggestion</h4>
                        <p className="text-sm text-muted-foreground">
                            Do you want to accept this suggestion?
                        </p>
                    </div>
                    <div className="grid gap-4">
                        <div className="grid grid-cols-3 items-center gap-4">
                            <Label htmlFor="width">Name</Label>
                            <div className="col-span-2">
                                <p className="text-sm text-muted-foreground">{name}</p>
                            </div>
                        </div>
                        <div className="grid grid-cols-3 items-start gap-4">
                            <Label htmlFor="description">Description</Label>
                            <div className="col-span-2">
                                <p className="text-xs text-muted-foreground break-words">{data.longDescription}</p>
                            </div>
                        </div>
                        <div className="grid grid-cols-3 items-center gap-4">
                            <Label htmlFor="height">Value</Label>
                            <div className="col-span-2">
                                <p className="text-sm text-muted-foreground">{value}</p>
                            </div>
                        </div>
                    </div>
                    <Button className="w-full" onClick={() => {
                        disabled? toast({
                            title: 'Error',
                            description: 'You have already selected this value',
                            status: 'error',
                            duration: 3000,
                            isClosable: true,
                            position: 'top-right',
                          }) : handleAcceptSuggestion(data);
                    }}>Accept Suggestion</Button>
                </div>
            </PopoverContent>
        </Popover>
    )
}

export default SuggestionPill